var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link && _vm.link.name)?_c('nuxt-link',{staticClass:"back-link",attrs:{"to":_vm.link}},[_c('i',{staticClass:"icon icon-chevron-left"}),_vm._v(" "+_vm._s(_vm.t('generic.back'))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }